import Vue from 'vue'
import i18n from '@/plugins/i18n'
import App from './App.vue'
import router from './router'
import Ripple from 'vue-ripple-directive'
import VueClipboards from 'vue-clipboards'
import store from '@/store'
import resizeMixin from './mixins/resizeMixin'
import setBreakpointByWindow from './plugins/resize'

Vue.config.productionTip = false

Vue.use(VueClipboards)
Vue.use(setBreakpointByWindow)

Ripple.color = 'rgba(0, 0, 0, 0.08)'
Ripple.zIndex = 10
Vue.directive('ripple', Ripple)

new Vue({
  router,
  i18n,
  store,
  mixins: [resizeMixin],
  render: h => h(App)
}).$mount('#app')
